<template>
  <component
    :is="currentConfig"
    :initial-config="config"
    @configChanged="onConfigChanged"
  />
</template>

<script>
import LollipopConfig from '@/components/question/chartConfigs/LollipopConfig';
import BarConfig from '@/components/question/chartConfigs/BarConfig';
import HistogramConfig from '@/components/question/chartConfigs/HistogramConfig';
import TreemapConfig from '@/components/question/chartConfigs/TreemapConfig';
import { CHART_TYPES } from '@/store';
import PieConfig from '@/components/question/chartConfigs/PieConfig';

export default {
  name: 'ChartConfig',
  components: {
    TreemapConfig,
    LollipopConfig,
    BarConfig,
    HistogramConfig,
    PieConfig,
  },
  props: {
    chart_type: {
      type: [String],
      default: CHART_TYPES.LOLLIPOP,
    },
    config: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
  },
  computed: {
    currentConfig() {
      if (this.chart_type === CHART_TYPES.LOLLIPOP) {
        return LollipopConfig.name;
      } else if (this.chart_type === CHART_TYPES.BAR) {
        return BarConfig.name;
      } else if (this.chart_type === CHART_TYPES.HISTOGRAM) {
        return HistogramConfig.name;
      } else if (this.chart_type === CHART_TYPES.TREEMAP) {
        return TreemapConfig.name;
      } else if (this.chart_type === CHART_TYPES.PIE) {
        return PieConfig.name;
      }
      return false;
    },
  },
  methods: {
    onConfigChanged(config) {
      this.$emit('configChanged', config);
    },
  },
};
</script>

<style scoped></style>
